module.exports = __webpack_public_path__ + "static/media/bridge.cfe9185e.png";